import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@material-ui/core'

const AreaFormModal = ({ open, area, onClose, onSave }) => {
  const isEdit = !!area
  const [name, setName] = React.useState('')
  const [phase, setPhase] = React.useState('')

  React.useEffect(() => {
    if (open) {
      setName(area?.name || '')
      setPhase(area?.phase || '')
    }
  }, [open, area])

  const handleSubmit = () => {
    if (!name.trim()) return
    onSave({ name: name.trim(), phase: phase.trim() || null })
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? 'Edit Area' : 'New Area'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Area Name"
          fullWidth
          margin="dense"
          value={name}
          onChange={e => setName(e.target.value)}
          inputProps={{ maxLength: 200 }}
          autoFocus
          required
        />
        <TextField
          label="Phase (optional)"
          fullWidth
          margin="dense"
          value={phase}
          onChange={e => setPhase(e.target.value)}
          placeholder="e.g. Phase 1"
          inputProps={{ maxLength: 100 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={!name.trim()}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AreaFormModal
